import Big from 'big.js'
import { atom } from 'jotai'
import { getPricesStore } from 'services/price-history/utils'
import { createAtomsWithQuery } from '../atomic-factory'
import { QUERY_KEY_PRICE } from '../keys'
import { DEFAULT_REFETCH_INTERVAL } from '../refetch-intervals'
import {
  type PriceRequest,
  type PriceRequestAtoms,
  type PriceResponse,
  defaultPriceRequest,
} from './model'

export const parseV2Price = (price: Big, params: PriceRequest): PriceResponse => {
  return {
    chainId: params.chainId,
    currency: params.sellCurrency,
    price: price,
  }
}

export const outputIndexV2Query = async <T>({
  queryKey: [, params],
}: {
  queryKey: [string, PriceRequest]
}) => {
  const prices = getPricesStore()
  const productPrices = Object.values(
    prices[`${params.sellCurrency.chainId}:${params.sellCurrency.address}`],
  )
  const productPrice = Big(productPrices[productPrices.length - 1])
  return parseV2Price(productPrice, params) as T
}

export const priceIndexV2Factory = () => {
  const priceRequestParamsAtom = atom<PriceRequest>(defaultPriceRequest)

  const mainProperties = createAtomsWithQuery<
    PriceResponse,
    PriceRequest,
    null,
    null,
    [string, PriceRequest]
  >(
    { first: priceRequestParamsAtom },
    QUERY_KEY_PRICE,
    outputIndexV2Query<PriceResponse>,
    DEFAULT_REFETCH_INTERVAL,
    'outputIndexV2Query',
  )

  return { params: priceRequestParamsAtom, ...mainProperties } as PriceRequestAtoms
}
